import Link from 'next/link';
import pluralize from 'pluralize';
import { memo } from 'react';

import {
  FileStatusButton,
  FileStatusIconCompleted,
  FileStatusSubtitle,
  FileStatusTitle,
} from '@air/feature-file-status/ui';
import { Close } from '@air/next-icons';

import { PaneItemTW } from '~/components/FileStatusTrackingPane/PaneItemTW';
import { Routes } from '~/constants/routes';
import { type BoardDeletionTask, type GetCompletedMetadata } from '~/store/tasks/types';

export type DeleteBoardCompletedPanelItemProps = {
  metadata: GetCompletedMetadata<BoardDeletionTask>;
  onClear: () => void;
};

export const DeleteBoardCompletedPanelItem = memo(
  ({ metadata: { boardIds }, onClear }: DeleteBoardCompletedPanelItemProps) => {
    return (
      <PaneItemTW
        truncate={false}
        avatar={<FileStatusIconCompleted />}
        title={<FileStatusTitle>Deleted successfully</FileStatusTitle>}
        subtitle={
          <FileStatusSubtitle className="truncate">
            {pluralize('Board', boardIds.length, true)} moved to{' '}
            <Link
              href={Routes.media.recentlyDeleted}
              className="cursor-pointer font-semibold text-altitude-9 hover:text-altitude-11 hover:underline"
            >
              Recently deleted
            </Link>
          </FileStatusSubtitle>
        }
        buttons={
          <FileStatusButton label="Clear" onClick={onClear}>
            <Close className="size-4" />
          </FileStatusButton>
        }
      />
    );
  },
);

DeleteBoardCompletedPanelItem.displayName = 'DeleteBoardCompletedPanelItem';
